<div class="datepicker-cal-wrap">
  <bs-datepicker-inline
    [bsValue]="initialDate"
    (bsValueChange)="onValueChange($event)"
    [bsConfig]="{
      rangeInputFormat: 'YYYY-MM-DD',
      dateInputFormat: 'YYYY-MM-DD',
      showWeekNumbers: false,
      selectFromOtherMonth: true,
    }"
    [maxDate]="maxDate"
  >
  </bs-datepicker-inline>
</div>
